import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomAlphabetItem from './CustomAlphabetItem';

const mapArrToMap = (arr) => {
  const map = new Map();
  var Regx = /^[A-Za-z]$/;
  arr.forEach((item) => {
    let firstChar = item[0];
    if (!Regx.test(firstChar)) {
      firstChar = '#'
    } else {
      firstChar = firstChar.toUpperCase();
    }
    if (map.get(firstChar) == null) {
      map.set(firstChar, [item]);
    } else {
      const arr = map.get(firstChar);
      arr.push(item);
      map.set(firstChar, arr)
    }

  })
  return map;
}
class CustomAlphabetList extends Component {
  constructor(props) {
    super(props);
    this.mapPos = null;
  }
  registerPos = (id, top) => {
    if (this.mapPos) {
      this.mapPos.set(id, top);
    }
  }
  handleAlphaClick = (char) => {
    const offset = this.mapPos.get(char);
    if (offset !== undefined && this.scroller) {
      const scrollerRect = this.scroller.getBoundingClientRect();
      const scrollTop = window.scrollY + scrollerRect.top + offset - 150;
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  }
  render() {
    const { generateFn, style, data, className } = this.props;
    const map = mapArrToMap(data);
    this.mapPos = new Map();
    const keyArr = Array.from(map.keys())
    keyArr.sort();
    return (
      <div
        className={className}
        style={{
          position: 'relative',
          ...(style ? style : {})
        }}
      >
        <div
          style={{
            width: '100%',
            paddingRight: 12,
          }}
          ref={(ref) => { this.scroller = ref }}
        >
          {
            keyArr.map((char) => {
              if (map.get(char) != null) {
                return (
                  <CustomAlphabetItem
                    id={`${char}`}
                    suffix={``}
                    key={char}
                    registerPos={this.registerPos}
                  >
                    {
                      map.get(char).map((item, index) => {
                        return generateFn(item, index);
                      })
                    }
                  </CustomAlphabetItem>
                )
              }
            })
          }

        </div>
        <div
          style={{
            position: 'fixed',
            top: '50%',
            right: 12,
            transform: 'translateY(-50%)',
            color: '#AAA',
            zIndex: 100
          }}
        >
          {
            keyArr.map(item => {
              return (
                <div
                  key={item}
                  style={{
                    fontSize: 9.5,
                    verticalAlign: 'top',
                    cursor: 'pointer',
                    color: '#AAA'
                  }}
                  onClick={() => { this.handleAlphaClick(item) }}
                >
                  {item}
                </div>
              )
            })
          }
        </div>
      </div>

    );
  }
}

CustomAlphabetList.propTypes = {
  generateFn: PropTypes.func,
  style: PropTypes.string,
  data: PropTypes.any,
  className: PropTypes.string
}

export default CustomAlphabetList;
